import { positionDropdown } from '.'

const SPACE_RIGHT_TOOLTIP = 20

export const calculateDropdownPosition = (
  parentRef,
  dropdownRef,
  position,
  dropdownSpace,
) => {
  const nodePosition = {}

  const {
    top: parentTop,
    left: parentLeft,
    bottom: parentBottom,
    right: parentRight,
  } = parentRef.current.getBoundingClientRect()

  switch (position) {
    case positionDropdown.TOP_CENTER:
      nodePosition.top =
        parentTop - dropdownRef.current?.offsetHeight - dropdownSpace
      nodePosition.left =
        parentLeft -
        (dropdownRef.current?.offsetWidth - parentRef.current?.offsetWidth) / 2
      break
    case positionDropdown.TOP_START_LEFT:
      nodePosition.top =
        parentTop - dropdownRef.current?.offsetHeight - dropdownSpace
      nodePosition.left =
        parentLeft - dropdownRef.current?.offsetWidth + SPACE_RIGHT_TOOLTIP
      break
    case positionDropdown.TOP_START_RIGHT:
      nodePosition.top =
        parentTop - dropdownRef.current?.offsetHeight - dropdownSpace
      nodePosition.left = parentLeft
      break
    case positionDropdown.TOP_END_LEFT:
      nodePosition.top =
        parentTop - dropdownRef.current?.offsetHeight - dropdownSpace
      nodePosition.left = parentRight - dropdownRef.current?.offsetWidth
      break
    case positionDropdown.TOP_END_RIGHT:
      nodePosition.top =
        parentTop - dropdownRef.current?.offsetHeight - dropdownSpace
      nodePosition.left = parentRight
      break
    case positionDropdown.BOTTOM_CENTER:
      nodePosition.top = parentBottom + dropdownSpace
      nodePosition.left =
        parentLeft -
        (dropdownRef.current?.offsetWidth - parentRef.current?.offsetWidth) / 2
      break
    case positionDropdown.BOTTOM_START_LEFT:
      nodePosition.top = parentBottom + dropdownSpace
      nodePosition.left = parentLeft - dropdownRef.current?.offsetWidth
      break
    case positionDropdown.BOTTOM_START_RIGHT:
      nodePosition.top = parentBottom + dropdownSpace
      nodePosition.left = parentLeft
      break
    case positionDropdown.BOTTOM_END_LEFT:
      nodePosition.top = parentBottom + dropdownSpace
      nodePosition.left = parentRight - dropdownRef.current?.offsetWidth
      break
    case positionDropdown.BOTTOM_END_RIGHT:
      nodePosition.top = parentBottom + dropdownSpace
      nodePosition.left = parentRight
      break
    case positionDropdown.LEFT_CENTER:
      nodePosition.top =
        parentTop -
        (dropdownRef.current?.offsetHeight - parentRef.current?.offsetHeight) /
          2
      nodePosition.left =
        parentLeft - dropdownRef.current?.offsetWidth - dropdownSpace
      break
    case positionDropdown.LEFT_START:
      nodePosition.top = parentTop
      nodePosition.left =
        parentLeft - dropdownRef.current?.offsetWidth - dropdownSpace
      break
    case positionDropdown.LEFT_END:
      nodePosition.top = parentBottom - dropdownRef.current?.offsetHeight
      nodePosition.left =
        parentLeft - dropdownRef.current?.offsetWidth - dropdownSpace
      break
    case positionDropdown.RIGHT_CENTER:
      nodePosition.top =
        parentTop -
        (dropdownRef.current?.offsetHeight - parentRef.current?.offsetHeight) /
          2
      nodePosition.left = parentRight + dropdownSpace
      break
    case positionDropdown.RIGHT_START:
      nodePosition.top = parentTop
      nodePosition.left = parentRight + dropdownSpace
      break
    case positionDropdown.RIGHT_END:
      nodePosition.top = parentBottom - dropdownRef.current?.offsetHeight
      nodePosition.left = parentRight + dropdownSpace
      break
    default:
      nodePosition.top = parentTop - dropdownRef.current?.offsetHeight
      nodePosition.left = parentLeft
  }

  return nodePosition
}
